import { t } from 'i18n';
import { styled } from '@teko/ui';
import { Text } from '@teko/ecommerce/mobile';
import React from 'react';

import { getTrackingData } from '@teko/tracking';

interface RecommendedKeywordProps {
  onClick: (keyword: string) => void;
  popularKeywords?: string[];
}
const StyledSearchTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
`;
const StyledRecommendedKeyword = styled.div`
  margin: 8px 0 4px;
`;
const RecommendedKeywordWrapper = styled.div`
  padding-top: 4px;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
`;
const RecommendedKeywordItem = styled.div`
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  border-radius: 999px;
  background: #f5f5f5;
  color: #333;
  margin: 0 4px 10px 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #ececec;
  }
`;
export const RecommendedKeyword: React.FC<RecommendedKeywordProps> = ({
  popularKeywords,
  onClick,
}: RecommendedKeywordProps) => {
  return (
    <StyledRecommendedKeyword>
      <StyledSearchTitle>
        <Text fontWeight="500" textTransform="uppercase" color="#82869E">
          {t('Từ khóa phổ biến')}
        </Text>
      </StyledSearchTitle>
      <RecommendedKeywordWrapper>
        {popularKeywords?.map((term, index: number) => {
          return (
            <RecommendedKeywordItem
              onClick={(): void => onClick(term)}
              key={index}
              {...getTrackingData({
                isTrackContent: true,
                regionName: 'popularKeyword',
                contentName: term,
                target: 'searchProductResult',
                payload: JSON.stringify({
                  screenName: 'searchProduct',
                  index,
                }),
              })}
            >
              {term}
            </RecommendedKeywordItem>
          );
        })}
      </RecommendedKeywordWrapper>
    </StyledRecommendedKeyword>
  );
};
